import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    layout: {
      navPos: 'left', //top, bottom, left, right, false
      toolbar: 'top', //top, bottom, false
      boxed: false, //true, false
      roundedCorners: false, //true, false
      viewAnimation: 'fade-top' // fade-left, fade-right, fade-top, fade-top-in-out, fade-bottom, fade-bottom-in-out, fade, false
    },
    splashScreen: true,
    logged: false,
    userdata: {},
    isLoadingPage: false,
    allowedRole: []
  },
  mutations: {
    setLayout(state, payload) {
      if (payload && payload.navPos !== undefined)
        state.layout.navPos = payload.navPos

      if (payload && payload.toolbar !== undefined)
        state.layout.toolbar = payload.toolbar

      if (payload && payload.boxed !== undefined)
        state.layout.boxed = payload.boxed

      if (payload && payload.roundedCorners !== undefined)
        state.layout.roundedCorners = payload.roundedCorners

      if (payload && payload.viewAnimation !== undefined)
        state.layout.viewAnimation = payload.viewAnimation
    },
    setLogin(state, payload) {
      console.log('payload login', payload)
      state.logged = true
      state.userdata = payload
    },
    setAllowedRole(state, payload) {
      state.allowedRole = payload
    },
    setLogout(state, payload) {
      state.layout.navPos = null
      state.layout.toolbar = null
      state.logged = false
      state.userdata = {}
    },
    setSplashScreen(state, payload) {
      state.splashScreen = payload
    },
    isLoadingPage(state, payload) {
      state.isLoadingPage = payload
    }
  },
  actions: {

  },
  getters: {
    isLoadingPage(state, getters) {
      return state.isLoadingPage
    },
    layout(state, getters) {
      return state.layout
    },
    navPos(state, getters) {
      return state.layout.navPos
    },
    toolbar(state, getters) {
      return state.layout.toolbar
    },
    boxed(state, getters) {
      return state.layout.boxed
    },
    roundedCorners(state, getters) {
      return state.layout.roundedCorners
    },
    viewAnimation(state, getters) {
      return state.layout.viewAnimation
    },
    isLogged(state, getters) {
      return state.logged
    },
    accessToken(state, getters) {
      return state.userdata.token
    },
    firstName(state, getters) {
      return state.userdata.users.first_name
    },
    splashScreen(state, getters) {
      return state.splashScreen
    },
    companyID(state, getters) {
      return state.userdata.company.id
    },
    companyName(state, getters) {
      return state.userdata.company.name
    },
    companyStatus(state, getters) {
      return state.userdata.company.status
    },
    companyType(state, getters) {
      return state.userdata.company.type
    },
    isCompanyPic(state, getters) {
      return state.userdata.user.is_company_pic
    },
    userID(state, getters) {
      return state.userdata.user.id
    },
    email(state, getters) {
      return state.userdata.user.email
    },
    userName(state, getters) {
      return state.userdata.users.username
    },
    fullName(state, getters) {
      return state.userdata.user.fullname
    },

    isPic(state, getters) {
      return typeof state.userdata.user_profile.is_pic !== 'undefined' ? state.userdata.user_profile.is_pic : false
    },
    isChecker(state, getters) {
      // console.log(state.userdata.user_profile)
      return typeof state.userdata.user_profile.is_checker !== 'undefined' ? state.userdata.user_profile.is_checker : false
    },

    bussinessId(state, getters) {
      return state.userdata.bussinessId
    },
    // companyName(state, getters){
    // 	return state.userdata.type == 2 ? state.userdata.company_name : 'Personal'
    // },
    // companyName(state, getters){
    // 	return state.userdata.type == 2 ? state.userdata.company_name : 'Personal'
    // },
    token(state, getters) {
      return state.userdata.token
    },
    role(state, getters) {
      return state.userdata.user.role
    },
    selectedManagePancer(state, getters) {
      return state.selectedManagePancer
    },
    detailInformation(state, getters) {
      return state.setSelectedCompany
    },
    roleId(state, getters) {
      return state.userdata.user.role_id
    },
    internalDetail(state, getters) {
      return state.userdata ? state.userdata.user.branch : {}
    }
  },
  plugins: [
    // createPersistedState({
    // 	paths: ['layout']
    // }),
    createPersistedState({
      storage: {
        getItem: key => Cookies.get(key) ? atob(Cookies.get(key)) : null,
        setItem: (key, value) => Cookies.set(key, btoa(value), { expires: 3, secure: false, domain: '', path: '/' }),
        removeItem: key => Cookies.remove(key)
      }
    }),
  ],
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store.js